import { AxiosPromise } from "axios";
import { accountApiConfig, ops } from "./config";
import {
  LocationDto,
  LocationsResourceApi,
  TransferFilesDto,
} from "../generated/account-client";

const api = new LocationsResourceApi(accountApiConfig);

const AccountLocationApi = {
  getLocation(id: string, internalId: number = 0): AxiosPromise<LocationDto> {
    return api.getLocation(id, internalId, ops());
  },
  updateLocation(dto: LocationDto): AxiosPromise<void> {
    return api.updateLocation(dto, ops());
  },
  deleteLocation(id: number): AxiosPromise<void> {
    return api.deleteLocation(id, ops());
  },
  transferTimberDesign(dto: TransferFilesDto): AxiosPromise<void> {
    return api.transferDigitalProducts(dto, ops());
  },
};

export default AccountLocationApi;
